module.exports = __webpack_public_path__ + "static/media/screen-behavioral-06.a5485071.jpg";